"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveCashBalanceFeedPointer = void 0;
const common_1 = require("@finley-technologies/common");
const mapCsvToBorrowerCashBalancesFeed_1 = require("./mapCsvToBorrowerCashBalancesFeed");
const cashBalanceFeedPointerMethod_1 = require("./parafinAtalaya1/cashBalanceFeedPointerMethod");
const cashBalanceFeedPointerMethod_2 = require("./parafinSiliconValleyBank1/cashBalanceFeedPointerMethod");
const cashBalanceFeedPointerMethod_3 = require("./rampCiti1/cashBalanceFeedPointerMethod");
const cashBalanceFeedPointerMethod_4 = require("./rampGoldmanSachs1/cashBalanceFeedPointerMethod");
const configs = [
    {
        pointer: 'generic',
        method: mapCsvToBorrowerCashBalancesFeed_1.mapCsvToBorrowerCashBalancesFeed,
    },
    cashBalanceFeedPointerMethod_1.cashBalancePointerConfig,
    cashBalanceFeedPointerMethod_2.cashBalancePointerConfig,
    cashBalanceFeedPointerMethod_3.cashBalancePointerConfig,
    cashBalanceFeedPointerMethod_4.cashBalancePointerConfig,
];
const resolveCashBalanceFeedPointer = (pointer) => {
    const found = configs.filter((config) => config.pointer === pointer);
    (0, common_1.finleyAssert)(found.length === 1, `resolveCashBalanceFeedPointer: Found [${found.length}] implementations for [pointer:${pointer}]`);
    return found[0].method;
};
exports.resolveCashBalanceFeedPointer = resolveCashBalanceFeedPointer;
//# sourceMappingURL=resolveCashBalanceFeedPointer.js.map